module.exports = __webpack_public_path__ + "img/scan.179c1920.svg";